import { useQuery } from "@apollo/client";
var AUTH_PAGES_VERIFY_USER_QUERY = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "AuthPagesVerifyIfUserExists"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "value"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "verifyUser"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "value"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "value"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "messages"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "field"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "message"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 148,
    source: {
      body: "query AuthPagesVerifyIfUserExists($value: String!) {\n  verifyUser(value: $value) {\n    success\n    messages {\n      field\n      message\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
export var useVerifyUserQuery = function useVerifyUserQuery() {
  var _useQuery = useQuery(AUTH_PAGES_VERIFY_USER_QUERY, {
      skip: true
    }),
    validateEmailQuery = _useQuery.refetch;

  /**
   * use res?.data?.verifyUser.success to check if the user IS NOT registered in the db
   */
  return {
    validateEmailQuery: validateEmailQuery
  };
};